import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { openNotification } from '../../../../helpers/notification';

export default function RejectNewConsultant({ open, onClose, consultant }) {
  const [saving, setSaving] = useState(false);

  const handleReject = async () => {
    setSaving(true);
    try {
      // const res = await approveConsultant(consultant?.userId);
      // const { data, status } = res?.result;
      // openNotification({
      //   type: 'success',
      //   title: status?.desc,
      // });
      onClose();
    } catch (error) {
      const errmsg = error?.data?.result?.desc;
      openNotification({
        type: 'error',
        title: errmsg,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Reject Consultant
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent>
        <Alert severity="error" icon={false}>
          You are about to Reject {consultant?.fullName} as a Consultant
        </Alert>
        <br />
        <Typography>{`Ensure that all neccessary checks and reviews have been done before performing this action`}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pt: 2, pb: 3 }}>
        <Button
          type="button"
          variant="contained"
          color="error"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          sx={{ textTransform: 'none', borderRadius: 20 }}
          onClick={handleReject}
        >
          Yes, Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
}
